import { getServiceProvider, IServiceProvider } from '../../../services';
import { select, takeLeading } from 'redux-saga/effects';
import actions from '../actions';
import selectors from '../selectors';

const checkUpdateSaga = takeLeading(actions.appUpdate.request.type, function* () {
  const serviceProvider: IServiceProvider = yield getServiceProvider();
  const appUpdateService = serviceProvider.appUpdateService;

  const updateAvailable = selectors.selectIsAppUpdateAvailable(yield select());
  if (!updateAvailable) {
    yield appUpdateService.checkForUpdates();
  }
});

const refreshSaga = takeLeading(actions.appUpdate.updateApp.type, function* () {
  const serviceProvider: IServiceProvider = yield getServiceProvider();
  serviceProvider.appUpdateService.update();
});

const sagas = [checkUpdateSaga, refreshSaga];

export default sagas;
